<script setup lang="ts">
import { devLogger, useAssets } from "@xlabmedical/medic-web-framework";
import { computed } from "vue";

const props = withDefaults(
    defineProps<{
        type?: string | "project" | "order";
        icon?: string;
        count?: number;
        tooManyIcons?: boolean;
    }>(),
    {
        type: "order",
        icon: "/icons/ik_shared_04_128.png",
        count: 0,
        tooManyIcons: false,
    },
);

const assets = useAssets();

const unreadNotificationsText = computed(() => {
    const parts: string[] = [];

    if (props.count > 0) {
        devLogger.debug("unreadNotificationsText patient.value push: ");
        parts.push(`${props.count} unread ${props.type} notifications`);
    } else {
        parts.push("No unread notifications");
    }

    return parts.join("<br/>");
});

const screenWidth = ref(window.innerWidth);

const updateWidth = () => {
    screenWidth.value = window.innerWidth;
};

onMounted(() => {
    window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
    window.removeEventListener("resize", updateWidth);
});

const iconSize = computed(() => {
    return 24;
});

const maxNotifications = computed(() => {
    return props.count > 99;
});

const countComputed = computed(() => {
    return maxNotifications.value ? "99+" : props.count;
});

const badgeWidth = computed(() => {
    return maxNotifications.value ? "16px" : "14px";
});

const badgeOffsetBottom = computed(() => {
    return "-3px";
});

const badgeOffsetRight = computed(() => {
    return "-3px";
});
</script>

<template>
    <div class="icon-with-badge">
        <img
            :src="assets.getAssetUrl(props.icon)"
            :style="{ width: `${iconSize}px`, height: `${iconSize}px` }"
            v-tooltip="{ value: unreadNotificationsText, escape: false }"
            alt="Shared" />
        <span v-if="props.count > 0" class="badge" v-tooltip="{ value: unreadNotificationsText, escape: false }">
            {{ countComputed }}
        </span>
    </div>
</template>

<style scoped>
.icon-with-badge {
    position: relative;
    display: inline-block;
    flex: 0 0 24px;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
}

.icon-with-badge > img {
    width: 100%;
    height: 100%;
    display: block; /* removes baseline gap */
}

.icon-with-badge .badge {
    position: absolute;
    right: v-bind(badgeOffsetRight);
    bottom: v-bind(badgeOffsetBottom);
    width: v-bind(badgeWidth);
    height: v-bind(badgeWidth);
    border-radius: 9999px;
    background: #ffffff;
    color: #000;
    font-size: 10px;
    line-height: 1; /* don’t stretch */
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    box-shadow: 0 0 0 0px #111827; /* outline to separate from icon; match your sidebar bg */
    z-index: 0;
}
</style>
